const tasks = [
    {
        id: 1,
        title: 'Topnav layout design',
        date: '14 Oct, 2019',
        task: 'Waiting',
        user: ['assets/images/users/avatar-4.jpg', 'assets/images/users/avatar-5.jpg'],
        budget: 145,
        status: 'upcoming'
    },
    {
        id: 2,
        title: 'Create a New Landing UI',
        date: '15 Oct, 2019',
        task: 'Approved',
        user: ['assets/images/users/avatar-6.jpg', 'assets/images/users/avatar-7.jpg'],
        budget: 112,
        status: 'upcoming'
    },
    {
        id: 3,
        title: 'Create a Skote Logo',
        date: '15 Oct, 2019',
        task: 'Waiting',
        user: ['assets/images/users/avatar-5.jpg'],
        budget: 86,
        status: 'upcoming'
    },
    {
        id: 4,
        title: 'Brand logo design',
        date: '12 Oct, 2019',
        task: 'Complete',
        user: ['assets/images/users/avatar-6.jpg'],
        budget: 132,
        status: 'inprogress'

    },
    {
        id: 5,
        title: 'Create a Blog Template UI',
        date: '13 Oct, 2019',
        task: 'Pending',
        user: ['assets/images/users/avatar-8.jpg', 'assets/images/users/avatar-1.jpg'],
        budget: 103,
        status: 'inprogress'
    },
    {
        id: 6,
        title: 'Skote Dashboard UI',
        date: '13 Oct, 2019',
        task: 'Complete',
        user: ['assets/images/users/avatar-2.jpg'],
        budget: 94,
        status: 'inprogress'
    },
    {
        id: 7,
        title: 'Redesign - Landing page',
        date: '10 Oct, 2019',
        task: 'Complete',
        user: ['assets/images/users/avatar-4.jpg'],
        budget: 145,
        groupId: 3,
        status: 'completed'
    },
    {
        id: 8,
        title: 'Multipurpose Landing',
        date: '09 Oct, 2019',
        task: 'Complete',
        user: ['assets/images/users/avatar-6.jpg', 'assets/images/users/avatar-7.jpg'],
        budget: 92,
        groupId: 3,
        status: 'completed'
    },
    {
        id: 9,
        title: 'Skote landing Psd',
        date: '15 Oct, 2019',
        task: 'Waiting',
        user: ['assets/images/users/avatar-5.jpg'],
        budget: 86,
        groupId: 3,
        status: 'completed'
    },
];

const memberList = [
    {
        id: 1,
        profile: "assets/images/users/avatar-1.jpg",
        name: "Albert Rodarte",
        checked: false
    },
    {
        id: 2,
        profile: "assets/images/users/avatar-2.jpg",
        name: "Hannah Glover",
        checked: false
    },
    {
        id: 3,
        profile: "assets/images/users/avatar-3.jpg",
        name: "Adrian Rodarte",
        checked: false
    },
    {
        id: 4,
        profile: "assets/images/users/avatar-4.jpg",
        name: "Frank Hamilton",
        checked: false
    },
    {
        id: 5,
        profile: "assets/images/users/avatar-5.jpg",
        name: "Justin Howard",
        checked: false
    },
    {
        id: 6,
        profile: "assets/images/users/avatar-6.jpg",
        name: "Michael Lawrence",
        checked: false
    },
    {
        id: 7,
        profile: "assets/images/users/avatar-7.jpg",
        name: "Oliver Sharp",
        checked: false
    },
    {
        id: 8,
        profile: "assets/images/users/avatar-8.jpg",
        name: "Richard Simpson",
        checked: false
    }
]

export { tasks, memberList };
